export default {"src":"/_next/static/media/illustration-delivery.357ff058.svg","height":152,"width":152};